import { Box, Typography } from '@mui/material';
import { TrendyolOrderProduct } from '../../../interfaces/Trendyol/TrendyolOrderProduct';
import { sharedColors, sharedStyles } from '../../../utils/Style';
import { TrendyolOrder } from '../../../interfaces/Trendyol/TrendyolOrder';

interface ProductRowProps {
  product: TrendyolOrderProduct;
}

const ProductRow = (props: ProductRowProps) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Typography sx={{ ...sharedStyles.body2, fontWeight: 'bold' }}>
        {props.product.productName}
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 0.2,
          flexWrap: 'wrap',
        }}
      >
        <Typography sx={sharedStyles.body2}>Barkod:</Typography>
        <Typography sx={{ ...sharedStyles.body2, color: sharedColors.gray5 }}>
          {props.product.barcode}
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 0.2,
          flexWrap: 'wrap',
        }}
      >
        <Typography sx={sharedStyles.body2}>Miktar:</Typography>
        <Typography sx={{ ...sharedStyles.body2, color: sharedColors.gray5 }}>
          {props.product.quantity.toString()}
        </Typography>
      </Box>
    </Box>
  );
};

interface TrendyolProductsCellProps {
  order: TrendyolOrder;
}

export const TrendyolProductsCell = (props: TrendyolProductsCellProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        maxHeight: 250,
        overflowY: 'auto',
      }}
    >
      {props.order.products.map((product, i) => (
        <ProductRow key={i} product={product} />
      ))}
    </Box>
  );
};
